import { registerPlugin } from "@capacitor/core";

export type Appearance = "light" | "dark" | "system";

interface VidimoAppearancePlugin {
  set: (options: { appearance: Appearance }) => Promise<void>;
}

/**
 * Android-only bridge to `AppCompatDelegate.setDefaultNightMode`
 * (`apps/mobile/android/app/src/main/java/world/superhost/app/VidimoAppearancePlugin.java`),
 * so the system-bar strips SystemBars paints on older WebViews follow the
 * in-app Appearance rather than the phone's. No web or iOS implementation: the
 * caller ([`components/system-theme-sync.tsx`](../../components/system-theme-sync.tsx))
 * only reaches this on native Android.
 */
export const VidimoAppearance =
  registerPlugin<VidimoAppearancePlugin>("VidimoAppearance");
